export const SUPPLIER_PERFORMANCE_QUERY_KEYS = {
	mySuppliers: (companyId: number, filters?: Record<string, unknown>) =>
		["my-suppliers", companyId, filters] as const,
	supplierDetail: (companyId: number, supplierId: number) =>
		["supplier-detail", companyId, supplierId] as const,
	supplierRatings: (companyId: number, supplierId: number) =>
		["supplier-ratings", companyId, supplierId] as const,
	supplierEngagements: (companyId: number, supplierId: number) =>
		["supplier-engagements", companyId, supplierId] as const,
	awardedProjects: (companyId: number, supplierId: number) =>
		["awarded-projects", companyId, supplierId] as const,
	performanceCategories: () => ["performance-categories"] as const,
	performanceRating: (companyId: number, ratingId: number) =>
		["performance-rating", companyId, ratingId] as const,
	latestRating: (
		companyId: number,
		supplierId: number,
		projectId?: number | null,
		rfxId?: number | null
	) => ["latest-rating", companyId, supplierId, projectId, rfxId] as const,
} as const;
